<template>
  <v-card class="mx-auto flex-grow-1">
    <v-toolbar short color="red accent-2" dense dark elevation="0" class="m-0 p-0">
      <v-toolbar-title class="m-0 pt-4">
        <p class="subtitle-2 text-center white--text font-weight-normal">
          <v-icon class="mx-2" color="lighten">mdi-cake</v-icon> Proximos Aniversários
        </p>
      </v-toolbar-title>
    </v-toolbar>

    <v-list two-line>
      <v-list-item-group active-class="red--text">
        <template v-for="(item, index) in visibleBirthdays">
          <v-list-item :key="item.title">
            <template v-slot:default="{ active }">
              <v-list-item-avatar size="32">
                <v-img :src="`${image}${item.profile_image}`"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.full_name"></v-list-item-title>
                <v-list-item-subtitle
                  class="text--primary"
                  v-text="item.birthdate"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                <v-icon v-if="!active" color="grey lighten-1"> mdi-star </v-icon>
                <v-icon v-else color="red"> mdi-star </v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-divider v-if="index + 1 < visibleBirthdays.length" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-card-actions class="flex-grow-0">
      <v-pagination
        v-if="birthdays.length >= perPage"
        v-model="page"
        color="red accent-2"
        circle
        :length="Math.ceil(birthdays.length / perPage)"
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<script>
import RESOURCES from '@/global/resources'
import { mapState } from 'vuex'
export default {
  data: function () {
    return {
      page: 1,
      perPage: 5,
      image: RESOURCES.ASSETS_PROFILE_IMAGES(),
      selected: [2],
      ordenedBirthdays: [],
    }
  },
  computed: {
    ...mapState('employees', ['birthdays']),
    visibleBirthdays() {
      return this.ordenedBirthdays.slice((this.page - 1) * this.perPage, this.page * this.perPage)
    },
  },
  created: function () {
    this.birthdays.map((elem) => {
      const data = elem.birthdate.split('-')
      this.ordenedBirthdays.push({ ...elem, birthdate: data[2] + '/' + data[1] })
    })
  },
  methods: {
    orderBirthdays(dataA, dataB) {
      if (dataA.birthdate < dataB.birthdate) {
        return -1
      }
      if (dataA.birthdate > dataB.birthdate) {
        return 1
      }
      return 0
    },
  },
}
</script>
